import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Typography, alpha } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { ReactComponent as ClientFormIcon } from "../../icons/TaskListEdit.svg";

import { useCurrentUserRole } from "../../hooks/useCurrentUser";
import { UserRole } from "../../constants";

import { useLocation, useNavigate } from "react-router-dom";
import { ClientFormClientListDto } from "@growth-machine-llc/stridist-api-client";
import { colorSystem } from "../../theme";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(2.5),
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.common.white, 0.05)
        : colorSystem.blue5,
    "&:first-child": {
      marginTop: 0,
    },
  },

  name: {
    fontSize: 16,
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
    maxWidth: "100%",
  },

  status: {
    fontSize: 14,
    fontWeight: 500,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: "6px",
    flexShrink: 0,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.common.white, 0.1)
        : colorSystem.white,
    "&::before": {
      content: "''",
      display: "inline-block",
      width: 8,
      height: 8,
      borderRadius: "50%",
      marginRight: theme.spacing(1),
    },
  },

  completed: {
    color: colorSystem.green,
    "&::before": {
      backgroundColor: colorSystem.green,
    },
  },
  incomplete: {
    color: colorSystem.orange,
    "&::before": {
      backgroundColor: colorSystem.orange,
    },
  },
  description: {
    color: theme.palette.text.secondary,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    gap: theme.spacing(1),
  },
}));

export interface ClientFormCardItemProps extends BoxProps {
  clientForm: ClientFormClientListDto;
}

export function ClientFormCardItem(props: ClientFormCardItemProps) {
  const s = useStyles();
  const navigate = useNavigate();
  const { className, clientForm, ...other } = props;
  const { name, slug, created, submittedAt } = clientForm;
  const location = useLocation();
  const role = useCurrentUserRole();
  const href = `${
    role === UserRole.COACH ? location.pathname.replace("/overview", "") : ""
  }/forms/${slug}`;

  const handleClick = React.useCallback(() => navigate(href), [href]);

  return (
    <Box className={clsx(s.root, className)} onClick={handleClick} {...other}>
      <Box className={s.header}>
        <Typography className={s.name}>{name}</Typography>
        <Typography
          className={clsx(s.status, submittedAt ? s.completed : s.incomplete)}
        >
          {submittedAt ? "Completed" : "Incomplete"}
        </Typography>
      </Box>
      <Typography className={s.description}>
        {created.format("MMM DD, YYYY")}
      </Typography>
    </Box>
  );
}
